import { focus, maxBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { colors, spacing } = theme;

const nodeLink = css`
  text-decoration: none;
  line-height: 1.75;
  color: ${colors.neutralDarker};
  margin: ${stack(spacing.sm)};
  transition: background-color 150ms linear;

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      margin: ${stack(spacing.lg)};
    `,
  )};

  &.focus-visible:focus {
    ${focus};
    border-radius: ${pxToRem(8)};
  }

  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
      color: ${colors.blueNavy};
    }
  }

  @media (hover: none) {
    &:active {
      background-color: ${colors.bluePattens};
    }
  }
`;

export const parentNodeLink = css`
  ${nodeLink}
  display: flex;
  align-items: center;
  position: relative;
  left: 0.125rem;

  img {
    margin-right: ${pxToRem(spacing.md)};
  }

  &[data-is-active='true'] {
    font-weight: bold;
    display: block;
  }
`;

export const childNodeLink = css`
  ${nodeLink}
  padding-left: ${pxToRem(36)};
  display: block;
`;

export const list = css`
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  color: ${colors.neutralDarker};
`;
